import * as StartPermit from '../schemas/permits/Officeworks/startPermit.json'
import * as EndPermit from '../schemas/permits/Officeworks/endPermit.json'

export default {
    type: 'Officeworks Permit',
    schemas: {
        'Start Permit': StartPermit,
        'Sign-off Permit': EndPermit,
    },
}